import { APIClient } from "../../../../api/api_helper";
import { GetUserData } from "../../../../common/service/CommonService";
import { Admin_API } from "../../../../api/url_helper";
/* ------------------------------------------------------------------
 * TYPES
 * ------------------------------------------------------------------ */

interface CurrentUser {
  userid: number;

}

interface RolePayload {
  roleid?: number | null;
  title?: string;
  description?: string;
  createdby?: number;
  updatedby?: number;
  updatereason?: string;
}

type Year = string | number;
type DashboardType = string | number;


/* ------------------------------------------------------------------
 * API CLIENT
 * ------------------------------------------------------------------ */

const api = new APIClient();

/* ------------------------------------------------------------------
 * ROLE API
 * ------------------------------------------------------------------ */

export const roleApiService = {

  // SELECT ALL METHOD
  getSelectAllData: (
    searchText?: string | null,
    pageNumber: number = 1,
    pageSize: number = 10,
  ) => {
    const payload = {
      status: "A",
      searchtext: searchText || null,
      currentpage: pageNumber,
      pagesize: pageSize,
    };
    return api.create(Admin_API.Role_API + "SelectAll", payload);
  },

   getDropdownData: () => {
    const payload = {
      status: 'A',
    };
    return api.create(Admin_API.Role_API + "Dropdown", payload);
  },

  // SELECT METHOD
  getSelectData: (id: number | undefined | null) => {
    const database =  process.env.REACT_APP_DATABASE || "";
    return api.get(Admin_API.Role_API + "Select?id=" + id + "&database=" + database);
  },

  // INSERT METHOD
  insertData: (payload_data: RolePayload) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      createdby: user.userid,
    };
    return api.create(Admin_API.Role_API + "Insert", payload);
  },

  // UPDATE METHOD
  updateData: (payload_data: RolePayload) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      ...payload_data,
      updatedby: user.userid,
    };
    return api.create(Admin_API.Role_API + "Update", payload);
  },

  // DELETE METHOD
  deleteData: (payload_data: { id: number | null; updatereason: string;}) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      roleid: payload_data.id,
      updatereason: payload_data.updatereason,
      updatedby: user.userid
    };
    return api.create(Admin_API.Role_API + "Delete", payload);
  },
};



